var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{attrs:{"fluid":"","fill-height":""}},[_c('v-content',{staticClass:"home-page"},[_c('v-row',[_c('v-col',{staticClass:"mx-auto pt-0",attrs:{"sm":"12","md":"12"}},[_c('homePage')],1)],1),_c('v-row',[_c('v-col',{attrs:{"id":"more"}},[_c('Location')],1)],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }